import { AUTH_BANNER_CLEAR } from "./AuthBannerActionTypes";
import { Dispatch, UnknownAction } from "redux";

export const clearAuthBannerAction = () => (dispatch: Dispatch<UnknownAction>) => {
  dispatch({
    type: AUTH_BANNER_CLEAR,
  });
};
